'use strict';

var _composeDecorators = require('./composeDecorators');

var _composeDecorators2 = _interopRequireDefault(_composeDecorators);

var _makeDecorator = require('./makeDecorator');

var _makeDecorator2 = _interopRequireDefault(_makeDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  composeDecorators: _composeDecorators2.default,
  makeDecorator: _makeDecorator2.default
};


/*****************
 ** WEBPACK FOOTER
 ** ../~/react-decorate/lib/index.js
 ** module id = 716
 ** module chunks = 0
 **/